import type { RouteRecordRaw } from 'vue-router';

export const PRODUCT_ROUTER: RouteRecordRaw[] = [
  {
    path: '/products',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/products/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/master/products/views/List.vue'),
        name: 'Products List',
        meta: {
          title: '아이템 마스터',
        },
      },
      {
        path: 'merchandise/create',
        component: () => import('@/modules/master/products/views/MerchandiseDetail.vue'),
        name: 'Merchandise Create',
        meta: {
          title: '상품 등록',
        },
      },
      {
        path: 'item/create',
        component: () => import('@/modules/master/products/views/ItemDetail.vue'),
        name: 'Item Create',
        meta: {
          title: '제품 등록',
        },
      },
      {
        path: 'set/create',
        component: () => import('@/modules/master/products/views/SetItem.vue'),
        name: 'Set Create',
        meta: {
          title: '세트 상품 등록',
        },
      },
      {
        path: 'material/create',
        component: () => import('@/modules/master/products/views/MaterialDetail.vue'),
        name: 'Material Create',
        meta: {
          title: '원부자재 등록',
        },
      },
    ],
  },
  {
    path: '/products/item/detail/:no',
    component: () => import('@/modules/master/products/views/ItemDetail.vue'),
    name: 'Item Detail',
    meta: {
      title: '제품 상세',
      requiresAuth: true,
    },
  },
  {
    path: '/products/merchandise/detail/:no',
    component: () => import('@/modules/master/products/views/MerchandiseDetail.vue'),
    name: 'Merchandise Detail',
    meta: {
      title: '상품 상세',
      requiresAuth: true,
    },
  },
  {
    path: '/products/set/detail/:no',
    component: () => import('@/modules/master/products/views/SetItem.vue'),
    name: 'Set Detail',
    meta: {
      title: '세트 상품 상세',
      requiresAuth: true,
    },
  },
  {
    path: '/products/material/detail/:no',
    component: () => import('@/modules/master/products/views/MaterialDetail.vue'),
    name: 'Material Detail',
    meta: {
      title: '원부자재 상세',
      requiresAuth: true,
    },
  },
];
